import {useTranslation} from 'next-i18next';
import {useCallback} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import FilterLabel from '@/src/jobPortal/clinicPositions/components/FilterLabel';
import {ORDER_JOBS_LIST} from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';
import css from '@/src/jobPortal/clinicPositions/styles/filters.module.css';
import {RadioButtonCommon} from '@/src/ui';

interface FilterByOrderProps {
  onChange: Function;
  selectedOrder: string;
}

const FilterByOrder = ({onChange, selectedOrder}: FilterByOrderProps) => {
  const {t} = useTranslation('common');

  const handleChange = useCallback(
    (event) => {
      onChange({
        [SEARCH_FILTERS.ORDER]: event.target.id,
      });
    },
    [onChange]
  );

  return (
    <div className={css.filterGroup}>
      {ORDER_JOBS_LIST.map((status) => {
        return (
          <div key={status.value} className={css.filterItem}>
            <RadioButtonCommon
              id={status.value}
              type="radio"
              name="status"
              label={<FilterLabel title={t(status.label)} />}
              checked={selectedOrder === status.value}
              onChange={handleChange}
              isSemibold={undefined}
              error={undefined}
            />
          </div>
        );
      })}
    </div>
  );
};

export default FilterByOrder;
